import '@/styles/app.scss';
import '@/styles/themes.scss';
import '@fontsource/maven-pro/500.css';
import '@fontsource/maven-pro/700.css';

import shared from '@lib/components';
const { App } = shared;

import { MobileMenuProvider } from '@/stores/mobileMenu';
import { MenuProvider } from '@/stores/menu';
import { AuthProvider, useAuthStore, verify, ready } from '@/stores/auth';

function _app ({ Component, pageProps }) {
  return (
    <MobileMenuProvider>
    <MenuProvider>
    <App.Provider
    authProvider={AuthProvider}
    >
    <App
    theme='iogames'
    readyAction={ready}
    verifyAction={verify}
    useAuthStore={useAuthStore}
    >
    <Component {...pageProps} />
    </App>
    </App.Provider>
    </MenuProvider>
    </MobileMenuProvider>
  );
}

export default _app;
